import { render, staticRenderFns } from "./ContactsCategory.vue?vue&type=template&id=1b914980&scoped=true&"
import script from "./ContactsCategory.vue?vue&type=script&lang=ts&"
export * from "./ContactsCategory.vue?vue&type=script&lang=ts&"
import style0 from "./ContactsCategory.vue?vue&type=style&index=0&id=1b914980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b914980",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
